import React from 'react';
import { ErrorBannerProps } from 'src/components/CookieSettings/ConsentBanner/ErrorBanner/types';
import { useTranslation } from 'react-i18next';
import { Notification, Button } from '@nxt-costco-com/forge-components';
import { Alert } from '@nxt-costco-com/forge-icons';
import { AppActionTypes } from 'src/types';
import {
    ErrorStyledButtonStack,
    buttonSX,
    popupConsentBannerSx,
    StyledBoxBannerContent,
    bannerTitleSx,
    notificationSx,
} from 'src/components/CookieSettings/ConsentBanner/styles';
import { setErrorBannerCloseStatus } from 'src/utils/errorUtils';
import { BannerAnnouncer } from 'src/components/CookieSettings/ConsentBanner/BannerAnnouncer';
import { Popup } from '@nxt-costco-com/forge-components';
import { useTracking } from 'react-tracking';

const trackingMessage = {
    uimsg: '*Page Type* | Cookie Settings | Error',
};
export const ErrorBanner: React.FC<ErrorBannerProps> = ({ open, dispatch, message }: ErrorBannerProps) => {
    const { t } = useTranslation('translation');
    const { trackEvent } = useTracking();
    trackEvent(trackingMessage);
    const handleErrorConsentBannerClose = () => {
        setErrorBannerCloseStatus('true');
        dispatch({ type: AppActionTypes.CLOSE_BANNER_ON_ERROR});
    };
    const bannerContent = () => (
        <StyledBoxBannerContent>
            <Notification sx={notificationSx} message={message} severity="critical" icon={<Alert />} />
            <ErrorStyledButtonStack>
                <Button sx={buttonSX} uniqueId="error-banner-close-button" onClick={handleErrorConsentBannerClose} variant="primary">
                    {t('banner.error.close')}
                </Button>
            </ErrorStyledButtonStack>
        </StyledBoxBannerContent>
    );
    return (
        <>
            {open && (
                <Popup
                    announcer={<BannerAnnouncer announcerText={t('banner.error.title')} />}
                    sx={popupConsentBannerSx}
                    title={t('banner.error.title')}
                    titleId="costcoConsentBannerTitle"
                    open={true}
                    position="Center"
                    popupName="Costco Consent Banner"
                    popupAriaLabel={t('banner.error.title')}
                    isNonCloseOrCollapsible={false}
                    isCloseable={true}
                    displayOnAllScreenSize={true}
                    renderContent={bannerContent}
                    closeButtonAriaLabel={t('banner.error.close')}
                    titleSx={bannerTitleSx}
                    onClose={handleErrorConsentBannerClose}
                ></Popup>
            )}
        </>
    );
};
